/* eslint-disable */
/**
 * GENERATED FILE — do not edit by hand.
 *
 * Regenerate with:  node scripts/generate-ecg-statements.js
 *
 * Source: microservices report-generator restEcgReport*.properties, which is
 * the same catalogue the algorithm and the PDF report use. Editing this file
 * directly would put the review screen out of step with the printed report.
 *
 * Every string below is the backend's own text, character for character. To
 * ADD a statement the backend has no key for, use `catalogue.custom.ts` — an
 * entry added here would be erased the next time this script runs.
 */
import {EcgStatement} from "./types"

export const GENERATED_STATEMENTS: EcgStatement[] = [
    {
        key: "heartRhythm.normalSinusRhythm",
        section: "heartRhythm",
        leads: false,
        text: {
            en: "Normal-frequency sinus rhythm",
            it: "Ritmo sinusale normofrequente.",
            uk: "Нормальний синусовий ритм",
        },
    },
    {
        key: "heartRhythm.bradySinusRhythm",
        section: "heartRhythm",
        leads: false,
        text: {
            en: "Bradycardic sinus rhythm",
            it: "Ritmo sinusale bradicardico.",
            uk: "Синусова брадикардія",
        },
    },
    {
        key: "heartRhythm.tachySinusRhythm",
        section: "heartRhythm",
        leads: false,
        text: {
            en: "Tachycardic sinus rhythm",
            it: "Ritmo sinusale tachicardico.",
            uk: "Синусова тахікардія",
        },
    },
    {
        key: "heartRhythm.aFibrillation",
        section: "heartRhythm",
        leads: false,
        text: {
            en: "Atrial fibrillation",
            it: "Fibrillazione atriale.",
            uk: "Фібріляція передсердь",
        },
    },
    {
        key: "heartRhythm.aFlutter",
        section: "heartRhythm",
        leads: false,
        text: {
            en: "Atrial flutter",
            it: "Flutter atriale.",
            uk: "Тріпотіння передсердь",
        },
    },
    {
        key: "heartRhythm.VEB",
        section: "heartRhythm",
        leads: false,
        text: {
            en: "Ventricular ectopic beats",
            it: "Battiti ectopici ventricolari.",
            uk: "Шлуночкові ектопія",
        },
    },
    {
        key: "heartRhythm.SVEB",
        section: "heartRhythm",
        leads: false,
        text: {
            en: "Supraventricular ectopic beats",
            it: "Battiti ectopici sopraventricolari.",
            uk: "Надшлуночкові ектопія",
        },
    },
    {
        key: "heartRhythm.vBigeminy",
        section: "heartRhythm",
        leads: false,
        text: {
            en: "Ventricular bigeminy rhythm",
            it: "Ritmo bigemino ventricolare.",
            uk: "Шлуночкова бігемінія",
        },
    },
    {
        key: "heartRhythm.svBigeminy",
        section: "heartRhythm",
        leads: false,
        text: {
            en: "Supraventricular bigeminy rhythm",
            it: "Ritmo bigemino sopraventricolare.",
            uk: "Надшлуночкова бігемінія",
        },
    },
    {
        key: "heartRhythm.vTrigeminy",
        section: "heartRhythm",
        leads: false,
        text: {
            en: "Ventricular trigeminy rhythm",
            it: "Ritmo trigemino ventricolare.",
            uk: "Шлуночкова тригемінія",
        },
    },
    {
        key: "heartRhythm.svTrigeminy",
        section: "heartRhythm",
        leads: false,
        text: {
            en: "Supraventricular trigeminy rhythm",
            it: "Ritmo trigemino sopraventricolare.",
            uk: "Надшлуночкова тригемінія",
        },
    },
    {
        key: "heartRhythm.vTachy",
        section: "heartRhythm",
        leads: false,
        text: {
            en: "Ventricular tachycardia",
            it: "Tachicardia ventricolare.",
            uk: "Шлуночкова тахікардія",
        },
    },
    {
        key: "heartRhythm.svTachy",
        section: "heartRhythm",
        leads: false,
        text: {
            en: "Supraventricular tachycardia",
            it: "Tachicardia sopraventricolare.",
            uk: "Надшлуночкова тахікардія",
        },
    },
    {
        key: "heartRhythm.vCouple",
        section: "heartRhythm",
        leads: false,
        text: {
            en: "Ventricular couple",
            it: "Coppia ventricolare.",
            uk: "Шлуночкова пара",
        },
    },
    {
        key: "heartRhythm.vTriplet",
        section: "heartRhythm",
        leads: false,
        text: {
            en: "Ventricular triplet",
            it: "Tripletta ventricolare.",
            uk: "Шлуночковий триплет",
        },
    },
    {
        key: "heartRhythm.svCouple",
        section: "heartRhythm",
        leads: false,
        text: {
            en: "Supraventricular couple",
            it: "Coppia sopraventricolare.",
            uk: "Надшлуночкова пара",
        },
    },
    {
        key: "heartRhythm.svTriplet",
        section: "heartRhythm",
        leads: false,
        text: {
            en: "Supraventricular triplet",
            it: "Tripletta sopraventricolare.",
            uk: "Надшлуночковий триплет",
        },
    },
    {
        key: "heartRhythm.junctional",
        section: "heartRhythm",
        leads: false,
        text: {
            en: "Junctional rhythm",
            it: "Ritmo giunzionale.",
            uk: "Сполучний ритм",
        },
    },
    {
        key: "heartRhythm.wanderingPM",
        section: "heartRhythm",
        leads: false,
        text: {
            en: "Wandering PM",
            it: "Segnapassi migrante.",
            uk: "Мандрівний пейсмейкер",
        },
    },
    {
        key: "heartRhythm.ectopicPWave",
        section: "heartRhythm",
        leads: false,
        text: {
            en: "Ectopic P wave",
            it: "Onda P ectopica.",
            uk: "Ектопічна Р хвиля",
        },
    },
    {
        key: "heartRhythm.unclassified",
        section: "heartRhythm",
        leads: false,
        text: {
            en: "Unclassified rhythm",
            it: "Ritmo non classificato.",
            uk: "Некласифікований ритм",
        },
    },
    {
        key: "heartRhythm.noise",
        section: "heartRhythm",
        leads: false,
        text: {
            en: "Noise",
            it: "Di rumore.",
            uk: "Шум",
        },
    },
    {
        key: "heartRhythm.pause",
        section: "heartRhythm",
        leads: false,
        text: {
            en: "Pause",
            it: "Pausa.",
            uk: "Пауза",
        },
    },
    {
        key: "avConduction.normal",
        section: "avConduction",
        leads: false,
        text: {
            en: "Normal atrioventricular conduction",
            it: "Conduzione atrioventricolare normale.",
            uk: "Нормальна атріовентрикулярна провідність",
        },
    },
    {
        key: "avConduction.firstAVBlock",
        section: "avConduction",
        leads: false,
        text: {
            en: "First-degree atrioventricular block",
            it: "Blocco atrioventricolare di primo grado.",
            uk: "Атріовентрикулярна блокада першого ступеня",
        },
    },
    {
        key: "avConduction.secondAVBlock",
        section: "avConduction",
        leads: false,
        text: {
            en: "Second-degree atrioventricular block",
            it: "Blocco atrioventricolare di secondo grado.",
            uk: "Атріовентрикулярна блокада другого ступеня",
        },
    },
    {
        key: "avConduction.thirdAVBlock",
        section: "avConduction",
        leads: false,
        text: {
            en: "Third-degree atrioventricular block",
            it: "Blocco atrioventricolare di terzo grado.",
            uk: "Атріовентрикулярна блокада третього ступеня",
        },
    },
    {
        key: "avConduction.shortPR",
        section: "avConduction",
        leads: false,
        text: {
            en: "Short PR interval",
            it: "Intervallo PR corto.",
            uk: "Короткий PR-інтервал",
        },
    },
    {
        key: "mitralP",
        section: "atrialHypertrophy",
        leads: false,
        text: {
            en: "Mitral P",
            it: "P mitralica.",
            uk: "P-mitrale",
        },
    },
    {
        key: "pulmonaryP",
        section: "atrialHypertrophy",
        leads: false,
        text: {
            en: "Pulmonary P",
            it: "P polmonare.",
            uk: "Р-pulmonale",
        },
    },
    {
        key: "qWaveInLead",
        section: "qWaves",
        leads: true,
        text: {
            en: "Q wave in %s",
            it: "Onda Q in %s.",
            uk: "Хвиля Q у відведенні %s",
        },
    },
    {
        key: "ivConduction.normal",
        section: "ivConduction",
        leads: false,
        text: {
            en: "Normal intraventricular conduction",
            it: "Conduzione intraventricolare normale.",
            uk: "Нормальна внутрішньошлуночкова провідність",
        },
    },
    {
        key: "ivConduction.completeRBBB",
        section: "ivConduction",
        leads: false,
        text: {
            en: "Right complete bundle branch block",
            it: "Blocco di branca destra completo.",
            uk: "Повна блокада правої ніжки пучка Гіса",
        },
    },
    {
        key: "ivConduction.incompleteRBBB",
        section: "ivConduction",
        leads: false,
        text: {
            en: "Right incomplete bundle branch block",
            it: "Blocco di branca destra incompleto.",
            uk: "Неповна блокада правої ніжки пучка Гіса",
        },
    },
    {
        key: "ivConduction.LAFB",
        section: "ivConduction",
        leads: false,
        text: {
            en: "Left anterior hemiblock",
            it: "Emiblocco anteriore sinistro.",
            uk: "Ліва передня фасцикулярна блокада",
        },
    },
    {
        key: "ivConduction.possibleLAFB",
        section: "ivConduction",
        leads: false,
        text: {
            en: "Possible left anterior hemiblock",
            it: "Possibile emiblocco anteriore sinistro.",
            uk: "Можлива ліва передня фасцикулярна блокада",
        },
    },
    {
        key: "ivConduction.completeLBBB",
        section: "ivConduction",
        leads: false,
        text: {
            en: "Left complete bundle branch block",
            it: "Blocco di branca sinistra completo.",
            uk: "Повна блокада лівої ніжки пучка Гіса",
        },
    },
    {
        key: "ivConduction.bifascicularBlock",
        section: "ivConduction",
        leads: false,
        text: {
            en: "Bifascicular block",
            it: "Blocco bifascicolare.",
            uk: "Біфасцикулярний блок",
        },
    },
    {
        key: "ivConduction.LPFB",
        section: "ivConduction",
        leads: false,
        text: {
            en: "Left posterior hemiblock",
            it: "Emiblocco posteriore sinistro.",
            uk: "Ліва задня фасцикулярна блокада",
        },
    },
    {
        key: "ivConduction.possibleLPFB",
        section: "ivConduction",
        leads: false,
        text: {
            en: "Possible left posterior hemiblock",
            it: "Possibile emiblocco posteriore sinistro.",
            uk: "Можлива ліва задня фасцикулярна блокада",
        },
    },
    {
        key: "repolarization.normal",
        section: "repolarization",
        leads: false,
        text: {
            en: "Normal cardiac repolarization",
            it: "Ripolarizzazione cardiaca normale.",
            uk: "Нормальна реполяризація серця",
        },
    },
    {
        key: "repolarization.stDepression",
        section: "repolarization",
        leads: true,
        text: {
            en: "ST depression in %s",
            it: "Sotto-slivellamento ST in %s.",
            uk: "депресія ST у %s",
        },
    },
    {
        key: "repolarization.aspecificStDepression",
        section: "repolarization",
        leads: true,
        text: {
            en: "Aspecific ST depression in %s",
            it: "Aspecifico sotto-slivellamento ST in %s.",
            uk: "Неспецифічна депресія ST у %s",
        },
    },
    {
        key: "repolarization.stElevation",
        section: "repolarization",
        leads: true,
        text: {
            en: "ST elevation in %s",
            it: "Sopra-slivellamento ST in %s.",
            uk: "Елевація ST в %s",
        },
    },
    {
        key: "repolarization.nonSignificantStElevation",
        section: "repolarization",
        leads: true,
        text: {
            en: "Non-significant ST elevation in %s",
            it: "Non significativo sopra-slivellamento ST in %s.",
            uk: "Незначна елевація ST у %s",
        },
    },
    {
        key: "repolarization.brugada",
        section: "repolarization",
        leads: false,
        text: {
            en: "Brugada syndrome",
            it: "Sindrome di Brugada.",
            uk: "Бругада синдром",
        },
    },
    {
        key: "repolarization.invertedTWave",
        section: "repolarization",
        leads: true,
        text: {
            en: "Inverted T wave in %s",
            it: "Onda T negativa in %s.",
            uk: "Інвертована хвиля Т у %s",
        },
    },
    {
        key: "conclusion.noisyLeads",
        section: "technical",
        leads: true,
        text: {
            en: "Interpretation is not complete because some leads were too noisy: %s",
            it: "L'interpretazione non è completa perché alcune derivazioni erano troppo rumorose: %s",
            uk: "Висновок не повний, оскільки деякі відведення мали нізьку якість сигналу: %s",
        },
    },
];
